export var ValidationErrors;

(function (ValidationErrors) {
  ValidationErrors["SizeError"] = "sizeError";
  ValidationErrors["FormatError"] = "formatError";
  ValidationErrors["QuantityError"] = "quantityError";
  ValidationErrors["TotalQuantityError"] = "totalQuantityError";
})(ValidationErrors || (ValidationErrors = {}));

export var UploadType;

(function (UploadType) {
  UploadType["Attachment"] = "attachment";
  UploadType["Credential"] = "credential";
})(UploadType || (UploadType = {}));

export var UploadAction;

(function (UploadAction) {
  UploadAction["Browse"] = "browse";
  UploadAction["Drag"] = "drag";
})(UploadAction || (UploadAction = {}));